import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

import { User } from '../models/user';

import { ErrorHandlerService } from '../services/error-handler.service';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { ApplicationPersonPhoto } from '../models/application-photo.model';

@Injectable()
export class ApplicationPersonPhotoService {

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService,
        private authService: AuthService) { }

    private photoLocator:string = null;
    private photoData:any = null;

    public savePhoto(applicationId: number, applicationPersonPhoto: ApplicationPersonPhoto): Observable<ApplicationPersonPhoto> {

        const headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        let user: User = this.authService.getUser();
        let url: string = environment.uriEndpoint + "v1/goesapp/users/" + user.userId + "/applications/" + applicationId + "/applicantPhoto";

        return this.http.put(url, applicationPersonPhoto, headers).pipe(
            map((res) => {
                return res;
            }),
            catchError(error => this.errorHandler.handleError(error))
        );
        
    }

    public retrievePhotoData(applicationId:number, locator:string):Observable<string> {

        if (locator === null || locator === undefined || locator === '') { 
          return of('');
        }
        
        let user: User = this.authService.getUser();
        let url: string = environment.uriEndpoint + "v1/goesapp/users/" + user.userId + "/applications/" + applicationId + "/rawPhotoData?locator=" + locator;

        const headers = new HttpHeaders()
            .set('Content-Type', 'text/plain; charset=utf-8');

        return this.http.get(url, { headers, responseType: 'text' as const })
        .pipe(
            map(response=> {

                this.photoData = response;
                return this.photoData;
            }),
            catchError(error => this.errorHandler.handleError(error))
        );  
    }

    public deletePhoto(applicationId:number):Observable<string> {
        
        let user: User = this.authService.getUser();
        let url: string = environment.uriEndpoint + "v1/goesapp/users/" + user.userId + "/applications/"+ applicationId +"/applicantPhoto";
        const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
        
        return this.http.delete(url, { headers, responseType: 'text' as const })
            .pipe(
                map(response=> "ok"),
                catchError(error => this.errorHandler.handleError(error))
            );  
    }

}